import React, { useState, useEffect } from "react";

import { Form, Formik } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";

import {
  SimpleGrid,
  Grid,
  GridItem,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  Flex,
  Text,
} from "@chakra-ui/react";

import { CustomButton } from "../../../../../components/CustomButton";
import { FocusError } from "../../../../../components/FocusError";
import pt from "date-fns/locale/pt";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import { hasFormChanged } from "../../../../../utils/hasFormChanged";
import { useAppContext } from "../../../../../../Context/MessageContextProvider";
import CriancaService from "../../../../../../main/services/CriancaService";
import { IrmaoTable } from "../../../ReferenciaFamiliar/Irmaos/Table";
import { CustomTextArea } from "../../../../../components/CustomTextArea";

const schema = Yup.object().shape({
  justificativaVisualizar: Yup.string().trim(),
});

export const VisualizarJustificativaModal = ({
  isOpen,
  onOpen,
  onClose,
  onCloseFiliacoes,
  form,
  idCrianca,
  fetchProcessosProcedimentoData,
  fetchAdocaoData,
  selected,
  definicao,
  fetchAtribuicao,
}) => {
  const [isVisual, setIsVisual] = useState(true);
  const [isTextareaFocused, setIsTextareaFocused] = useState(false);
  const {
    cadastrarProcessosProcedimentos,
    setCadastrarProcessosProcedimentos,
  } = useAppContext();

  const [initialValues, setInitialValues] = useState({
    justificativaVisualizar: "",
    concorrente: false,
  });

  const columnsJustificativaVisualizarPromotoria = [
    {
      Header: "Nome",
      accessor: "nome",
      Cell: (props) => {
        return <span title={props.value}>{props.value}</span>;
      },
      disableSortBy: true,
    },

    {
      Header: "Município",
      accessor: "municipioPromotoria",
      Cell: (props) => {
        return <Text whiteSpace={"nowrap"}>{props.value}</Text>;
      },
      disableSortBy: true,
    },
  ];

  const columnsJustificativaVisualizarVara = [
    {
      Header: "Nome",
      accessor: "nome",
      Cell: (props) => {
        return <span title={props.value}>{props.value}</span>;
      },
      disableSortBy: true,
    },

    {
      Header: "Comarca",
      accessor: "comarcaVara",
      Cell: (props) => {
        return <Text whiteSpace={"nowrap"}>{props.value}</Text>;
      },
      disableSortBy: true,
    },
  ];

  useEffect(() => {
    setInitialValues({
      justificativaVisualizar: selected?.justificativa
        ? selected?.justificativa
        : "",
      concorrente: selected?.promotoriaConcorrente
        ? selected?.promotoriaConcorrente
        : false,
    });
  }, [selected]);

  const backAlert = () => {
    if (cadastrarProcessosProcedimentos) {
      Swal.fire({
        title: "Tem certeza que deseja cancelar?",
        text: "As informações serão perdidas.",
        icon: "error",
        showCancelButton: true,
        confirmButtonColor: "#169499",
        cancelButtonColor: "#169499",
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
      }).then((result) => {
        if (result.isConfirmed) {
          onClose();
          setCadastrarProcessosProcedimentos(false);
          setIsVisual(true);
        }
      });
    } else {
      onClose();
      setIsVisual(true);
    }
  };
  const editarPromotoriaJuridica = async (id, valuesToSend) => {
    if (definicao !== "promotoria") {
      delete valuesToSend.concorrente;
    }
    try {
      definicao === "promotoria"
        ? await CriancaService.editarPromotoriaJuridica(id, valuesToSend)
        : await CriancaService.editarVaraInfancia(id, valuesToSend);
      Swal.fire({
        title: "Sucesso!",
        text: "Registro atualizado com sucesso!",
        icon: "success",
        confirmButtonText: "Continuar",
        confirmButtonColor: "#169499",
      }).then((result) => {});
      onClose();
      fetchAtribuicao();
    } catch (error) {
      console.log(error);
      Swal.fire({
        title: "Atenção!",
        text: error.response.data.message ? error.response.data.message : "",
        icon: "warning",
        confirmButtonText: "Fechar",
        confirmButtonColor: "#169499",
      });
    }
  };

  useEffect(() => {
    setDefaultLocale("pt-br");
    registerLocale("pt-br", pt);
  }, []);

  const handleSubmit = (values, actions) => {
    setTimeout(() => {
      const { justificativaVisualizar, concorrente } = values;

      const valuesToSend = {
        idOrgao: selected?.id ? Number(selected?.id) : null,
        justificativa: justificativaVisualizar
          ? justificativaVisualizar?.trim()
          : "",
        concorrente: concorrente,
      };
      editarPromotoriaJuridica(idCrianca, valuesToSend);
      setIsVisual(true);
      actions.setSubmitting(false);
    }, 200);
  };

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} isCentered size="4xl">
        <ModalOverlay />
        <ModalContent
          p={{ base: "5px", sm: "15px", md: "25px" }}
          bgColor="#FFF"
        >
          <ModalHeader
            p="0px"
            fontWeight={700}
            fontSize="14px"
            lineHeight="19.6px"
            color="#169499"
          >
            {"Visualizar Justificativa".toUpperCase()}
          </ModalHeader>
          <ModalBody
            p="0px"
            mt="25px"
            minH={{ base: "0px", md: "200px" }}
            pl="1px"
          >
            <Formik
              validationSchema={schema}
              initialValues={initialValues}
              onSubmit={handleSubmit}
              validateOnChange={false}
              validateOnBlur={false}
            >
              {(props) => (
                <Form style={{ width: "100%" }}>
                  {setCadastrarProcessosProcedimentos(
                    hasFormChanged(initialValues, props.values)
                  )}

                  <FocusError />
                  <Grid templateColumns="repeat(6, 1fr) 1fr" gap={2}>
                    <GridItem colSpan={7}>
                      <IrmaoTable
                        disableHeaderOptions={true}
                        mt={"0px"}
                        columns={
                          definicao === "promotoria"
                            ? columnsJustificativaVisualizarPromotoria
                            : columnsJustificativaVisualizarVara
                        }
                        data={[selected]}
                        entidade={"justificativa"}
                        justificativa={true}
                        filiacoes={[selected]}
                        fetchProcessosProcedimentoData={
                          fetchProcessosProcedimentoData
                        }
                      />
                    </GridItem>
                    <GridItem colSpan={7} mt={2}>
                      <CustomTextArea
                        fieldName={"justificativaVisualizar"}
                        label={"Justificativa"}
                        placeholder={"Informe a Justificativa"}
                        setIsTextareaFocused={setIsTextareaFocused}
                        maxLength={255}
                        isTextareaFocused={isTextareaFocused}
                        isDisabled={isVisual}
                        fontWeightLabel={700}
                      />
                    </GridItem>
                  </Grid>
                  <Flex justifyContent="end">
                    <SimpleGrid
                      mt="25px"
                      columns={2}
                      spacing="15px"
                      w={{ base: "100%", lg: "40%" }}
                    >
                      <CustomButton onClick={backAlert} label="Cancelar" />
                      {isVisual && (
                        <CustomButton
                          onClick={() => setIsVisual(false)}
                          label="Editar"
                        />
                      )}
                      {!isVisual && (
                        <CustomButton
                          type="submit"
                          translate="no"
                          isLoading={props.isSubmitting}
                          label="Salvar"
                        />
                      )}
                    </SimpleGrid>
                  </Flex>
                </Form>
              )}
            </Formik>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
